import type { IconNode } from '../types';

/**
 * @name hat-bowler
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiAxM2MwIDEuNyAyLjcgMyA2IDNzNi0xLjMgNi0zdi0zYTYgNiAwIDAgMC0xMiAwWiIgLz4KICA8cGF0aCBkPSJNNiA5YzAgMS43IDIuNyAzIDYgM3M2LTEuMyA2LTMiIC8+CiAgPHBhdGggZD0iTTYgOS4yQzMuNiAxMC4zIDIgMTIgMiAxNGMwIDMuMyA0LjUgNiAxMCA2czEwLTIuNyAxMC02YzAtMi0xLjYtMy43LTQtNC44IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/hat-bowler
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const hatBowler: IconNode = [
  ['path', { d: 'M6 13c0 1.7 2.7 3 6 3s6-1.3 6-3v-3a6 6 0 0 0-12 0Z', key: '164rxb' }],
  ['path', { d: 'M6 9c0 1.7 2.7 3 6 3s6-1.3 6-3', key: 'ewm28i' }],
  [
    'path',
    {
      d: 'M6 9.2C3.6 10.3 2 12 2 14c0 3.3 4.5 6 10 6s10-2.7 10-6c0-2-1.6-3.7-4-4.8',
      key: '1urjt8',
    },
  ],
];

export default hatBowler;
